"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PayoutContractErrorMessage = void 0;
var PayoutContractErrorMessage;
(function (PayoutContractErrorMessage) {
    PayoutContractErrorMessage["NotFound"] = "Payout contract not found";
})(PayoutContractErrorMessage || (exports.PayoutContractErrorMessage = PayoutContractErrorMessage = {}));
